import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { ArrowRight } from '@/icons/index';
import { Facebook, Instagram, Whatsapp } from '@/icons/social/light';

import SectionTitle from '../SectionTitle/SectionTitle';
import ActiveLink from '../ActiveLink/ActiveLink';

import styles from './styles.module.scss';

const TariffCardLight = ({ item, onClick, className }) => {
  const { t } = useTranslation();

  const isMultiSocial = item?.tariff_additional_info
    ?.map((item) => item.key)
    ?.includes('Instagram');

  return (
    <div
      onClick={onClick}
      className={classNames([styles.card, className])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.top}>
        <div className={styles.content}>
          <SectionTitle className={styles.title}>{item?.title}</SectionTitle>
          <ActiveLink href={item?.url}>
            <a
              target='_blank'
              className={styles.link}
              title={t('esim:common.details')}
              aria-label={t('esim:common.details')}
            >
              {t('esim:common.details')} <ArrowRight width={20} />
            </a>
          </ActiveLink>
        </div>
        <span className={styles.price}>
          <span className={styles.value}>{item?.price} AZN</span> /
          {t('esim:common.monthly')}
        </span>
      </div>
      <div className={styles.content}>
        <ul className={styles.list}>
          <li>
            <span> {item?.tariff_additional_info[0]?.key}</span>
            <span className={styles.value}>
              {item?.tariff_additional_info[0]?.value}
            </span>
          </li>
          <li>
            <span> {item?.tariff_additional_info[1]?.key}</span>
            <span className={styles.value}>
              {item?.tariff_additional_info[1]?.value}
            </span>
          </li>
          <li>
            <span className={styles.icons}>
              {isMultiSocial ? (
                <>
                  <Whatsapp />
                  <Facebook />
                  <Instagram />
                </>
              ) : (
                <Whatsapp />
              )}
            </span>
            <span className={styles.value}>
              {item?.tariff_additional_info[2]?.value}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TariffCardLight;
